"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PeaceOfMind() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="peaceofmind" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-6 transition-all duration-700 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight tracking-tight">
              Peace of Mind for Families
            </h2>
            <div className="space-y-4 text-lg text-muted-foreground leading-relaxed">
              <p>
                At Family First Senior Care, we understand that choosing the right care for a
                loved one is a profound decision. That is why we have created a
                small assisted living home with personalized care, dedicated to
                providing premier assisted living in Silver Spring, Maryland.
              </p>
              <p>
                With accommodations for up to just 5 seniors, our residents
                enjoy premier residential assisted living in Montgomery County,
                with private rooms, 24/7 dedicated caregiver support, and
                nutritious home-cooked meals in a warm, family-like atmosphere
                where every individual feels truly valued.
              </p>
            </div>
            <div className="pt-4">
              <Button asChild size="lg" className="rounded-full px-8 shadow-md">
                <Link to="/CareServicesPage">Learn More</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-[24px] overflow-hidden shadow-2xl shadow-shadow-color/10 ring-1 ring-border/50">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent mix-blend-overlay z-10 pointer-events-none"></div>
              <img src="https://optimal-muskrat.10web.cloud/wp-content/uploads/2026/03/IMG_3656-scaled.jpg" alt="Seniors enjoying a warm family-like environment with caregivers" className="w-full h-auto object-cover aspect-[4/3] md:aspect-square lg:aspect-[4/3] transform hover:scale-105 transition-transform duration-700 ease-in-out" loading="lazy" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-secondary/20 rounded-full blur-2xl -z-10"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/10 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>;
}